// src/component/items/SearchableSelect.tsx

import { useState } from "react";
import {
  Popover,
  PopoverHandler,
  PopoverContent,
  Input as MTInput,
  List,
  ListItem,
} from "@material-tailwind/react";

type Option = {
  label: string;
  value: string;
};

interface SearchableSelectProps {
  id: string;
  labelText: string;
  value: string;
  isRequired?: boolean;
  placeholder?: string;
  options: Option[];
  handleChange: any;
  error?: boolean;
}

export default function SearchableSelect({
  id,
  labelText,
  value,
  isRequired = false,
  placeholder = "Select",
  options,
  handleChange,
  error = false,
}: SearchableSelectProps) {
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = useState(false);

  const selectedOption = options.find((o) => o.value === value);
  const filteredOptions = options.filter((o) =>
    o.label.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="w-full">
      {/* <label className="block text-sm font-medium text-gray-700 mb-1">
        {labelText}
        {isRequired && <span className="text-red-500 ml-1">*</span>}
      </label> */}
      <Popover open={open} handler={setOpen} placement="bottom-start">
        <PopoverHandler>
          <div>
            <MTInput
              id={id}
              error={error}
              onClick={() => setOpen(true)}
              value={selectedOption?.label || ""}
              required={isRequired}
              crossOrigin=""
              size="lg"
              label={labelText}
              onChange={handleChange}
            />
          </div>
        </PopoverHandler>
        <PopoverContent className="p-2 w-[450px] max-h-[250px] overflow-y-auto z-[9999]">
          <MTInput
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search..."
            className="mb-2"
            crossOrigin=""
          />
          <List>
            {filteredOptions.map((opt) => (
              <ListItem
                key={opt.value}
                onClick={() => {
                  handleChange(opt.value);
                  setSearchText("");
                  setOpen(false);
                }}
                className="cursor-pointer"
              >
                {opt.label}
              </ListItem>
            ))}
            {filteredOptions.length === 0 && (
              <ListItem disabled>No results found</ListItem>
            )}
          </List>
        </PopoverContent>
      </Popover>
    </div>
  );
}
